import "bootstrap/js/src/modal";
import AOS from "aos";
import "aos/dist/aos.css";

import "./topbar";
import "./cookie-consent";
import "../styles/about.scss";

AOS.init();
